import addToCart from '../lib/addToCart';
import changeCart from '../lib/changeCart';
import {
  getWarrantyCartProperties,
  persistWarrantySelectionForProduct,
  clearWarrantyStorageForProduct,
} from '../lib/warrantySelection';

const getConfig = block => {
  const configScript = block.querySelector('[data-cart-warranty-config]');
  if (!configScript) return null;
  try {
    return JSON.parse(configScript.textContent);
  } catch (error) {
    console.error('Failed to parse cart warranty config:', error);
    return null;
  }
};

const setVisible = (element, visible) => {
  if (!element) return;
  element.hidden = !visible;
  element.classList.toggle('hidden', !visible);
};

const syncBlockUi = (block, { isEditing }) => {
  const hasSelection = Boolean(block.dataset.lineItemKey);
  const showOptions = isEditing || !hasSelection;
  const showBanner = hasSelection && !isEditing;

  setVisible(block.querySelector('[data-cart-warranty-selected]'), showBanner);
  setVisible(block.querySelector('[data-cart-warranty-options]'), showOptions);
};

const getSelectedFromRadio = radio => ({
  variantId: Number(radio.value),
  variantTitle: radio.dataset.variantTitle || '',
  variantPriceFormatted: radio.dataset.variantPriceFormatted || '',
});

const persistSelection = (parentProductId, selected) => {
  persistWarrantySelectionForProduct(parentProductId, selected);
};

const reloadCart = () => {
  document.dispatchEvent(new CustomEvent('cart:updated'));
  window.location.reload();
};

const applyWarrantySelection = async (block, config, selected) => {
  const parentProductId = config.parentProductId;
  const parentQuantity = Math.max(1, Number(block.dataset.parentQuantity) || 1);
  const lineItemKey = block.dataset.lineItemKey || config.lineItemKey;

  if (lineItemKey && config.variantId === selected.variantId) {
    syncBlockUi(block, { isEditing: false });
    return;
  }

  if (lineItemKey) {
    await changeCart(lineItemKey, 0);
  }

  await addToCart([
    {
      id: selected.variantId,
      quantity: parentQuantity,
      properties: getWarrantyCartProperties(parentProductId),
    },
  ]);

  persistSelection(parentProductId, selected);
  reloadCart();
};

const removeWarranty = async (block, config) => {
  const lineItemKey = block.dataset.lineItemKey || config.lineItemKey;
  if (!lineItemKey) return;

  await changeCart(lineItemKey, 0);
  clearWarrantyStorageForProduct(config.parentProductId);
  block.dataset.lineItemKey = '';
  reloadCart();
};

const initCartLineItemWarranty = () => {
  document.querySelectorAll('[data-cart-warranty]').forEach(block => {
    if (block.dataset.cartWarrantyInit === 'true') return;

    const config = getConfig(block);
    if (!config) return;

    block.dataset.cartWarrantyInit = 'true';
    if (config.lineItemKey) {
      block.dataset.lineItemKey = config.lineItemKey;
    }

    syncBlockUi(block, { isEditing: false });

    block.querySelector('[data-cart-warranty-edit]')?.addEventListener('click', () => {
      syncBlockUi(block, { isEditing: true });
      block.querySelector('[data-cart-warranty-option]:checked, [data-cart-warranty-option]')?.focus();
    });

    block.querySelector('[data-cart-warranty-remove]')?.addEventListener('click', async () => {
      try {
        await removeWarranty(block, config);
      } catch (error) {
        console.error('Error removing warranty cover from basket:', error);
      }
    });

    block.querySelectorAll('[data-cart-warranty-option]').forEach(radio => {
      radio.addEventListener('change', async () => {
        if (!radio.checked) return;

        try {
          await applyWarrantySelection(block, config, getSelectedFromRadio(radio));
        } catch (error) {
          console.error('Error updating warranty cover in basket:', error);
        }
      });
    });
  });
};

export default initCartLineItemWarranty;
